import React from 'react';

const NotFound = React.memo(() => <h1>Not Found</h1>);

export default NotFound;
